import React from 'react'
import { l } from '@manychat/manyui'

import { MetaInfo } from 'apps/aiAutomation/components/KnowledgeEditor/components/MetaInfo'
import { SourceTextEditor } from 'apps/aiAutomation/components/KnowledgeEditor/components/SourceTextEditor'
import { KnowledgeEntry, KnowledgeEntryType } from 'shared/api/requests/aiBusinessKnowledge/schemas'

export const ReadMode = ({ entry }: { entry: KnowledgeEntry }) => {
  return (
    <>
      <MetaInfo
        isNewEntry={false}
        url={entry.type === KnowledgeEntryType.LINK ? entry.data.url : ''}
        updatedAt={entry.updated_at}
      />

      <SourceTextEditor label={l.translate('Content')} readOnly value={entry.data.text} />
    </>
  )
}
